export default "__VITE_ASSET__CesK0pz6__"